import { render } from "./ShortAnswer.vue?vue&type=template&id=28b6c0e7&scoped=true"
import script from "./ShortAnswer.vue?vue&type=script&lang=js"
export * from "./ShortAnswer.vue?vue&type=script&lang=js"

import "./ShortAnswer.vue?vue&type=style&index=0&id=28b6c0e7&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b6c0e7"]])

export default __exports__